import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const Section = styled('section')`
  min-height: 268px;
  position: relative;
  color: ${({ theme }) => theme.color.white};
  background-color: ${({ theme }) => theme.color.noir};

  body[data-theme] & {
    color: var(--s-color-text-solid);
    background-color: var(--s-color-surface-1);
  }

  padding: ${({ theme }) => theme.x2space}rem;
  margin-bottom: ${({ theme }) => theme.x2space}rem;

  ${media.mdUp`
    padding: ${({ theme }) => theme.x4space}rem;
  `}

  ${media.lgUp`
  border-radius: 8px;
  `}

  @media print {
    break-inside: avoid;
  }
`;
